import { rem } from 'polished'
import styled from 'styled-components'

export const TagTitleWrapper = styled.span`
  font-size: ${rem(16)};
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: ${rem(8)};
  color: ${({ theme, color }) => theme.color[color]};
`
